import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d2a77cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "exportation-header" };
const _hoisted_2 = { class: "exportation-header__title" };
const _hoisted_3 = { class: "exportation-header__instruction" };
const _hoisted_4 = {
    key: 0,
    class: "exportation-header__audience"
};
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportationHeader',
    setup(__props) {
        const store = useStore();
        const audienceName = computed(() => store.getters['audienceManager/getAudienceName']);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('audiences.exportation.title')), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('audiences.exportation.select-below')), 1),
                (audienceName.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.$t('audiences.exportation.audience-exporting')) + " ", 1),
                        _createElementVNode("strong", null, _toDisplayString(audienceName.value), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
